import React, { Fragment } from 'react';
import { array, bool, number, object, shape, string } from 'prop-types';
import AmpAd from 'components/AmpAd';
import AmpAccordion from 'components/AmpAccordion';
import AmpGalleryItem from 'components/AmpGalleryItem';
import { BASE_AD_UNITS_AMP, MAX_SUB_UNIT_COUNT } from 'constants/ads/units';
import { pad } from 'util/string';
import styles from './styles';

const getNextAdUnit = count => {
  let unit = BASE_AD_UNITS_AMP.gallery;
  if (count <= MAX_SUB_UNIT_COUNT) {
    unit += `/AmpGallery_${pad(count)}`;
  }
  return unit;
};

function AmpUnzippedGallery(props) {
  const { images, post, resourceId, adOffset, hasPrism } = props;
  const [first, ...rest] = images;
  let slideCount = 0;
  let adCount = 0;
  return (
    <div className="Gallery Gallery--unzipped">
      <style jsx>{styles}</style>
      {first && (
        <AmpGalleryItem
          key={first.url}
          image={first}
          slidePos={++slideCount} // eslint-disable-line no-plusplus
          imageCount={images.length}
          post={post}
          hasPrism={hasPrism}
        />
      )}
      {rest && (
        <AmpAccordion>
          <header>
            <button
              className="Gallery__show-more"
              data-gtm-gallery-action="expand"
              data-gtm-gallery-type="unzipped"
              aria-label="Show more"
            >
              <span className="Gallery__show-more-message" />
            </button>
          </header>
          <div>
            {rest.map(img => {
              const slidePos = ++slideCount; // eslint-disable-line no-plusplus
              return (
                <Fragment key={img.url}>
                  <AmpGalleryItem
                    image={img}
                    slidePos={slidePos}
                    imageCount={images.length}
                    post={post}
                    hasPrism={hasPrism}
                  />
                  {BASE_AD_UNITS_AMP.gallery &&
                    adOffset &&
                    slidePos % adOffset === 0 && (
                      // Insert an ad if this slide pos is a multiple of adOffset
                      <div className="Gallery__ad">
                        <AmpAd
                          size={[300, 250]}
                          unit={getNextAdUnit(++adCount)} // eslint-disable-line no-plusplus
                          targeting={post && post.ads && post.ads.targeting}
                          resourceId={resourceId}
                        />
                      </div>
                    )}
                </Fragment>
              );
            })}
          </div>
        </AmpAccordion>
      )}
    </div>
  );
}

AmpUnzippedGallery.defaultProps = {
  post: {},
  resourceId: undefined,
  adOffset: undefined,
  hasPrism: false
};

AmpUnzippedGallery.propTypes = {
  images: array.isRequired, // eslint-disable-line react/forbid-prop-types
  resourceId: string,
  post: shape({
    ads: shape({
      targeting: object
    }),
    canonical: string
  }),
  adOffset: number,
  hasPrism: bool
};

export default AmpUnzippedGallery;
